// PhonicsLt07.js
// 包装组件：Letter Teams L07
// 路由：/phonics/lt07
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt07 } from './phonics/phonics_data_lt07';

function PhonicsLt07() {
  return <PhonicsLt letterData={letterDataLt07} />;
}

export default PhonicsLt07;
